import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const ListStyled = styled(Stack)({
  paddingLeft: 0,
  margin: 0,
  listStylePosition: 'inside',
});
